module.exports = __webpack_public_path__ + "img/0Q3A6963_L_Black_MockedUp.eb566ac5.jpg";